import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Root from '../Root';
import { initializeWidgetErrorTracker } from './errorTracker';
var render = function (store, journey) {
    initializeWidgetErrorTracker(journey);
    ReactDOM.render(_jsx(Provider, { store: store, children: _jsx(Root, {}) }), document.getElementById('root'));
};
export default render;
